import styled from 'styled-components'

export const Status = styled.div`
  display: flex;
`
